import { RedditSearch } from "../RedditSearch";

export const MobileRedditSearch = () => <RedditSearch isMobile />;
